// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgMinimizeIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M3 19v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2H5a2 2 0 0 1-2-2M3 9V4.414l-.707-.707a1 1 0 1 1 1.414-1.414l18 18a1 1 0 1 1-1.414 1.414L19.586 21H15a1 1 0 0 1 0-2h2.586L5 6.414V9a1 1 0 0 1-2 0m16-1V5h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 1 1-2 0" />
  </g>
);
export default SvgMinimizeIcon;
SvgMinimizeIcon.displayName = 'SvgMinimizeIcon';
